/**
 * @module plugins:highlight
 */
import Vue from 'vue'
import { vuePlugin as highlightjs } from '@/highlight'
import 'highlight.js/styles/atom-one-dark-reasonable.css'
Vue.use(highlightjs)
